import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const PRIEST_TOKEN = "pc_priest_token";

export const priestApi = axios.create({ baseURL: `${BASE}/api` });
priestApi.interceptors.request.use((c) => {
  const t = localStorage.getItem(PRIEST_TOKEN);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const plogin = (email, password) => priestApi.post("/auth/login", { email, password }).then((r) => r.data);
export const pme = () => priestApi.get("/auth/me").then((r) => r.data);
export const getDashboard = () => priestApi.get("/priest/dashboard").then((r) => r.data);
export const getMarketplace = () => priestApi.get("/priest/marketplace").then((r) => r.data);
export const sendProposal = (b) => priestApi.post("/priest/proposals", b).then((r) => r.data);
export const getAvailability = () => priestApi.get("/priest/availability").then((r) => r.data);
export const saveAvailability = (date, slots) => priestApi.put("/priest/availability", { date, slots }).then((r) => r.data);
export const getPriestProfile = () => priestApi.get("/priest/profile").then((r) => r.data);
export const getMessages = () => priestApi.get("/priest/messages").then((r) => r.data);

export function perr(e, fb = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  return d?.[0]?.msg || e?.message || fb;
}
